import { GetterTree } from 'vuex';
import { RootState } from '../../state';
import toolState from './state';

// eslint-disable-next-line no-shadow
export const enum GetterTypes {
  getLinearLoading = 'linearLoading',
  getSnackbar = 'getSnackbar'
}
type AuthGetterCtx<T> = (
  state: typeof toolState,
  getters: any,
  rootState: RootState,
  rootGetters: any
) => T;
export interface ToolGetters extends GetterTree<typeof toolState, RootState> {
  getLinearLoading: AuthGetterCtx<boolean>;
}
export const getters: GetterTree<typeof toolState, RootState> = {
  getLinearLoading: state => state.navLinearLoading,
  getSnackbar: state => state.snackBar
};
